
// Normalize the configured API base URL so a misconfigured env var can't
// silently turn absolute calls into relative ones (which makes the browser
// POST to the Vercel static host → "405 Method Not Allowed").
function normalizeBase(raw) {
  let url = (raw || 'http://localhost:4000/api').trim()
  // Add a protocol if the env var was set without one (e.g. "xxx.up.railway.app/api").
  if (!/^https?:\/\//i.test(url)) url = `https://${url}`
  // Strip any trailing slash so `${BASE}${path}` never produces a double slash.
  return url.replace(/\/+$/, '')
}

const BASE = normalizeBase(import.meta.env.VITE_API_URL)

function getToken() {
  return localStorage.getItem('temple_jwt')
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' }
  const token = getToken()
  if (token) headers['Authorization'] = `Bearer ${token}`

  let res
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    })
  } catch {
    throw new Error(`Cannot reach API server at ${BASE}. The backend may be offline or the URL is wrong.`)
  }

  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`)
  return data
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  delete: (path) => request('DELETE', path),
}
